import request from '@/utils/request'

// 获取系统配置
export function getsysconfig(data) {
  return request({
    url: '/user/getsysconfig',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data
  })
}